import ApiBase from "../api-base";

class EventsApi extends ApiBase {
    async getEvents(params) {
        return this.handleResponse(async () => {                                                                                                                                                                                                                                                                                          
            let response = await this.get(`/events`, params);
            return response.data;
        });
    }

    async getEvent(id) {
        return this.handleResponse(async () => {                                                                                                                                                                                                                                                                                          
            let response = await this.get(`/events/${id}`);
            return response.data;
        });
    }

    async getEventTypes() {
        return this.handleResponse(async () => {                                                                                                                                                                                                                                                                                          
            let response = await this.get(`/event-types`);
            return response.data;
        });
    }

    async getEventBooking(id, bookingId) {
        return this.handleResponse(async () => {                                                                                                                                                                                                                                                                                          
            let response = await this.get(`/events/${id}/bookings/${bookingId}`);
            return response.data;
        });
    }

    async search(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/events/public/search`, params, validationHandler);
            return response.data;
        });
    } 

    async getBookingCosts(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/events/${id}/quote-booking`, params, validationHandler);
            return response.data;
        });
    } 

    async updateBooking(id, bookingId, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/events/${id}/bookings/${bookingId}`, params, validationHandler);
            return response.data;
        });
    } 

    async getBookingQuoteCancellation(id, bookingId, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/events/${id}/bookings/${bookingId}/quote-cancel`, params, validationHandler);
            return response.data;
        });
    } 

    async cancelBooking(id, bookingId, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/events/${id}/bookings/${bookingId}/cancel`, {}, validationHandler);
            return response.data;
        });
    } 

    async bookEvent(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/events/${id}/book`, params, validationHandler);
            return response.data;
        });
    } 

    updateEventAttendees(id, params, validationCallback = this.validationHandler) {
        return this.handleResponse(async () => {
            let response = await this.post(`/events/${id}/attendees`, params, validationCallback);
            return response.data.data;
        });
    }

    updateEventAttendee(id, attendeeId, params, validationCallback = this.validationHandler) {
        return this.handleResponse(async () => {
            let response = await this.post(`/events/${id}/attendees/${attendeeId}`, params, validationCallback);
            return response.data.data;
        });
    }

    deleteEventAttendee(id, attendeeId, params = {}, validationCallback = this.validationHandler) {
        return this.handleResponse(async () => {
            let response = await this.delete(`/events/${id}/attendees/${attendeeId}`, params, validationCallback);
            return response.data.data;
        });
    }

    getEventAttendees(id) {
        return this.handleResponse(async () => {
            let response = await this.get(`/events/${id}/attendees`);
            return response.data;
        });
    }
}

export default new EventsApi();